import React, { useRef } from "react";
import TYPE from "../../../constant/TYPE";
import { getMathJaxNode } from "../mathjax/MathJax";

const SizeComparison = ( props ) => {

  const prevData = useRef( [] );
  const mathjaxRenderCount = useRef( 0 );

  const startKeyword = `\\begin{${ TYPE.LATEX_CODE.SIZE_COMPARISON }}`;
  const endKeyword = `\\end{${ TYPE.LATEX_CODE.SIZE_COMPARISON }}`;
  const data = props.children.slice( props.children.indexOf( startKeyword ) + startKeyword.length, props.children.indexOf( endKeyword ) ).split( '&' ).map( v => v.trim() );
  const changedDataCount = data.filter( ( v, i ) => prevData.current[ i ] !== v ).length;

  const MathJaxNode = getMathJaxNode( props.type );

  const COLUMNS = data.map( ( v, i ) => <td key={ i }><span className={ 1 === i ? 'round-inequalityBox' : 'inputTxt' }><MathJaxNode onRender={ renderMathJax }>{ v }</MathJaxNode></span></td> );

  const renderMathJax = () => {
    mathjaxRenderCount.current++;
    if ( changedDataCount === mathjaxRenderCount.current ) {
      prevData.current = data;
      mathjaxRenderCount.current = 0;
      props.onRender();
    }
  };

  return (
    <table className="tbl-inequalityBox">
      <tbody>
      <tr>{ COLUMNS }</tr>
      </tbody>
    </table>
  );

};

export default SizeComparison;
